import React from "react";
import styled from "styled-components";
import PositionContainer from "../shared/container";
import MainTitle from "../shared/heroTitles";
import Paragraph from "../shared/paragraphs";
import ContentBox from "../shared/contentBox";
import { StaticImage } from "gatsby-plugin-image";
import { useIntl } from "gatsby-plugin-react-intl";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 40px 0px;
  padding-top: 0px;

  a {
    color: #111111;
  }
  @media (max-width: 960px) {
    height: max-content;
    width: 100%;
  }
  .img {
    height: auto;
    @media (max-width: 960px) {
      width: 45%;
    }

    @media (max-width: 768px) {
      width: 327px;
      height: 246px;
    }
  }
`;

const ContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 50px;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  &:nth-child(1) {
    flex-direction: column;
  }
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  margin-top: 30px;
  @media (max-width: 560px) {
    width: 100%;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }
  .gatsby-image-wrapper {
    margin: auto;
    max-width: 45%;
  }
`;

const Box = styled.div`
  height: fit-content;
  width: fit-content;
  @media (max-width: 960px) {
    width: 100%;
  }
`;

function Img1() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.fr-control-panel.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.es-control-panel.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Img2() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.fr-control-panel-uninstall.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.es-control-panel-uninstall.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Img3() {
  const intl = useIntl();
  const Lang = intl.locale;
  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.fr-uninstall-button-control-panel.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.es-uninstall-button-control-panel.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Img4() {
  const intl = useIntl();
  const Lang = intl.locale;
  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.fr-allow.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.es-allow.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Img5() {
  const intl = useIntl();
  const Lang = intl.locale;
  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.fr-uninstall-progress.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.es-uninstall-progress.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Img6() {
  const intl = useIntl();
  const Lang = intl.locale;
  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.fr-uninstall-complete.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/uninstall/pdfcreator.es-uninstall-complete.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Uninstall() {
  const intl = useIntl();

  return (
    <Container>
      <PositionContainer>
        <ContentHolder>
          <Row>
            <MainTitle features={true}>
              {intl.formatMessage({
                id: "InstructionDeinstallTitle",
              })}
            </MainTitle>
            <TextContainer>
              <Paragraph type="center">
                {intl.formatMessage({
                  id: "InstructionDeinstallUnderTitle",
                })}
              </Paragraph>
            </TextContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 1`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionDeinstallStepOne",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 2`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionDeinstallStepTwo",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 3`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionDeinstallStepThree",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 4`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionDeinstallStepFour",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 5`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionDeinstallStepFive",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 6`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionDeinstallStepSix",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Img1 />
              <Img2 />
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Img3 />
              <Img4 />
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Img5 />
              <Img6 />
            </FlexContainer>
          </Row>
        </ContentHolder>
      </PositionContainer>
    </Container>
  );
}

export default Uninstall;
